import React from "react";
import { BodyCondition } from "../../../components";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionBodyConditionProps {
	isChild?: boolean;
	className?: string;
	ariaHidden?: boolean;
}

export const SectionBodyCondition: React.FC<SectionBodyConditionProps> = ({
	isChild = false,
	className,
	ariaHidden = false,
}) => {
	return (
		<WrappedSection
			sectionName="SectionBodyCondition"
			isChild={isChild}
			className={className}
			ariaHidden={ariaHidden}
		>
			<BodyCondition />
		</WrappedSection>
	);
};

export default SectionBodyCondition;
